const COOKIES_EXPIRATION_DATE_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 30; // 30 days

export const COOKIES_EXPIRATION_DATE = new Date(
  Date.now() + COOKIES_EXPIRATION_DATE_IN_MILLISECONDS,
);
